import React, { Component } from "react"
import { request } from "../../../api-client"
import styled from 'styled-components';
import { makeFitImageUrlWithSize } from '../../../utils';
import { get } from 'lodash';
import FaceFilters from '../../../components/FaceFilters';
import { getActiveChannel, getActiveClient, getStoredUser } from "../../../api-client/core/authentication/utils";
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../components/Loader';
import localization from "../../../config/localization";
import EventManager, {events} from "../../../utils/EventManager";



const MyContentContainer = styled.div`
  padding: 4px 16px;
  background: var(--main-color, #fff);
  min-height: calc(100vh - 75px);
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 24px;
  }
`;

const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  padding: 16px;
`;

const PhotoCard = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.02);
  }
`;

const PhotoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

class GridContentCreations extends Component {
    constructor(props) {  
      super(props)
      this.state = {
        contentCreations: [],
        client: null,
        loading: true,
        selectedPhoto: null,
        searchPerson: null,
        filters: [],
        genderFilter: null,
        ageRangeFilter: null,
        emotionFilter: null,
        facialFeaturesFilter: null,
        showContentCreationDialog: false,
        currentPlayingContent: {},
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 24,
        hasMore: true,
        filterParams: {}
      }
    } 

    componentDidMount = () => {
        this.requestContentCreations()
    }
    

    requestContentCreations = (clearResults = false) => {
      const options = {
        ...this.state.filterParams,
        page: this.state.currentPage,
        per_page: this.state.itemsPerPage
      };

      return request.people.myContent(getActiveChannel(), options)
        .then(response => {
          let results = [];

          if (!clearResults) {
            results = this.state.contentCreations.concat(response.data)
          } else {
            results = response.data
            setTimeout(() => window.scrollTo({top: 0, behavior: "smooth"}), 500)
          }

          this.setState({ 
            contentCreations:results,
            loading: false,
            totalPages: response.meta.last_page,
            currentPage: response.meta.current_page,
            hasMore: response.meta.current_page < response.meta.last_page,
          });
        });
    }
    
    getFilteredContentCreations = () => {
      const { 
        contentCreations, 
        searchPerson,
        genderFilter,
        ageRangeFilter,
        emotionFilter,
        facialFeaturesFilter 
      } = this.state;

      let filtered = contentCreations;

      if (searchPerson) {
        filtered = filtered.filter(contentCreation => contentCreation.person_id === searchPerson.value);
      }

      if (get(genderFilter, 'value')) {
        filtered = filtered.filter(contentCreation => 
          get(contentCreation, 'face_metadata.Gender.Value', '').toLowerCase() === genderFilter.value
        );
      }

      if (get(ageRangeFilter, 'value')) {
        const [min, max] = ageRangeFilter.value.split('-');
        filtered = filtered.filter(contentCreation => {
          const age = get(contentCreation, 'face_metadata.AgeRange.Value');
          if (max) {
            return age >= parseInt(min) && age <= parseInt(max);
          }
          return age >= parseInt(min);
        });
      }

      if (get(emotionFilter, 'value')) {
        filtered = filtered.filter(contentCreation => 
          get(contentCreation, 'face_metadata.Emotions', [])
            .some(emotion => emotion.Type.toLowerCase() === emotionFilter.value && emotion.Confidence > 50)
        );
      }

      if (get(facialFeaturesFilter, 'value')) {
        const [feature, value] = facialFeaturesFilter.value.split(':');
        filtered = filtered.filter(contentCreation => 
          get(contentCreation, `face_metadata.${feature}.Value`, false) === (value === 'true')
        );
      }

      return filtered;
    }

    handleFiltersChange = (filterParams) => {
      this.setState({ loading: true, currentPage: 1, hasMore: true, filterParams: filterParams }, () => {
        this.requestContentCreations(true);
      });
    }

    fetchMoreData = () => {
      if (!this.state.hasMore) return;
      this.setState(
        prev => ({ currentPage: prev.currentPage + 1 }),
        () => this.requestContentCreations(false)
      );
    };

    render() {
      const {  
        loading,
      } = this.state;

      if (getStoredUser().people == 0 || !getStoredUser().people.find(person => person.client_id === getActiveClient())) {
        return <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 48}}><h2 style={{ fontSize: 24, fontWeight: 700, color: "var(--main-font-color, #000)", margin: 0}}>{localization.get("navbar.my_content.no_results")}</h2></div>
      }

      return (
        <MyContentContainer>
          <h2 style={{ fontSize: 24, fontWeight: 700, color: "var(--main-font-color, #000)", margin: 0}}>{localization.get("navbar.my_content.title")}</h2>
          <br/>
          <FaceFilters 
            clientId={getActiveClient()}
            loadPersonOptions={this.loadPersonOptions}
            onFiltersChange={this.handleFiltersChange}
            hideGender
            hideAgeRange
            personId={getStoredUser().people.find(person => person.client_id === getActiveClient()).id}
            showPersonSearch
          />
          <br/>
          <InfiniteScroll
            dataLength={this.state.contentCreations.length}
            next={() => this.fetchMoreData()}
            hasMore={this.state.hasMore}
            loader={<div style={{height: '70px', paddingTop: 20, width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center'}}><Loader width={50} height={50} /></div>}
          >
            <PhotoGrid>
              {this.getFilteredContentCreations().length === 0 && <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><h2 style={{ fontSize: 24, fontWeight: 700, color: "var(--main-font-color, #000)", margin: 0}}>{localization.get("navbar.my_content.no_results")}</h2></div>}
              {this.getFilteredContentCreations().map(contentCreation => (
                <PhotoCard 
                  key={contentCreation.id} 
                  onClick={() => EventManager.getInstance().dispatch(events.OPEN_MATERIAL_MODAL, {
                      id: contentCreation.id, 
                      materialList: this.getFilteredContentCreations().map((item, index) => ({index, id: item.id}))
                    })}
                >
                  <PhotoImage 
                    src={makeFitImageUrlWithSize(contentCreation, 'md')} 
                    alt=""
                  />
                </PhotoCard>
              ))}
            </PhotoGrid>
          </InfiniteScroll>
        </MyContentContainer>
      )
    }
}

export default GridContentCreations;
